import { autoserialize, autoserializeAs } from "cerialize"
import {
  EvaluationValuationModel,
  AvailableToEvaluateModel
} from "./Evaluation.model"
import { BudgetRowModel, GrantType } from "../ArtistModels/artistForm.model"

export class FestExpertEvaluationLeaderModel {
  @autoserialize name: string;
  @autoserializeAs("music_experience") musicExperience: string;

  constructor(
    name: string,
    musicExperience: string
  ) {
    this.name = name
    this.musicExperience = musicExperience
  }
}

export class FestExpertEvaluationFileModel {
  @autoserialize id: number;
  @autoserializeAs("original_name") name: string;
  @autoserialize url: string;

  constructor(id: number, name: string, url: string) {
    this.id = id
    this.name = name
    this.url = url
  }
}

export class FestExpertEvaluationArtistModel {
  @autoserialize id: number;
  @autoserializeAs("form_id") formId: number;
  @autoserializeAs("photo_site") photoSite: string;
  @autoserialize name: string;
  @autoserialize genre: string;
  @autoserialize country: string;
  @autoserialize city: string;
  @autoserialize description: string;
  @autoserializeAs("instagram_url") instagramUrl: string | null;
  @autoserializeAs("youtube_url") youtubeUrl: string | null;
  @autoserializeAs("vkontakte_url") vkontakteUrl: string | null;
  @autoserializeAs("tiktok_url") tiktokUrl: string | null;
  @autoserializeAs("telegram_url") telegramUrl: string | null;
  @autoserializeAs("rutube_url") rutubeUrl: string | null;
  @autoserializeAs("max_url") maxUrl: string | null;
  @autoserializeAs("music_links") musicLinks: Array<string | null>;
  @autoserializeAs("project_name") projectName: string;
  @autoserializeAs("project_description") projectDescription: string;
  @autoserializeAs("project_relevance") projectRelevance: string;
  @autoserializeAs("project_point") projectPoint: string;
  @autoserializeAs("project_target_audience") projectTargetAudience:
    | string
    | null;
  @autoserializeAs("project_pr_strategy") projectPrStrategy: string;
  @autoserializeAs("project_start") projectStart: string;
  @autoserializeAs("project_end") projectEnd: string;
  @autoserializeAs("calendar_plan_text") calendarPlanText: string | null;
  @autoserializeAs("project_online_audience_expectations")
  projectOnlineAudienceExpectations: number | null;
  @autoserializeAs("project_offilne_audience_expectations")
  projectOffilneAudienceExpectations: number | null;
  @autoserializeAs("project_media_coverage_expectations")
  projectMediaCoverageExpectations: number | null;
  @autoserializeAs("project_expectations") projectExpectations: string;
  @autoserializeAs(BudgetRowModel, "budget_plan_json")
  budgetPlanJson: BudgetRowModel[];
  @autoserializeAs("project_budget_sources") projectBudgetSources: string;
  @autoserializeAs("grant_type") grantType: GrantType | null;
  @autoserializeAs("grant_amount") grantAmount: number | null;
  @autoserializeAs(FestExpertEvaluationLeaderModel)
  leader: FestExpertEvaluationLeaderModel;
  @autoserializeAs(FestExpertEvaluationFileModel) presentation: FestExpertEvaluationFileModel | null;

  constructor(
    id: number,
    formId: number,
    name: string,
    description: string,
    country: string,
    city: string,
    genre: string,
    instagramUrl: string | null,
    youtubeUrl: string | null,
    vkontakteUrl: string | null,
    tiktokUrl: string | null,
    telegramUrl: string | null,
    rutubeUrl: string | null,
    maxUrl: string | null,
    musicLinks: Array<string | null>,
    projectName: string,
    projectDescription: string,
    projectStart: string,
    projectEnd: string,
    projectPoint: string,
    projectTargetAudience: string | null,
    projectOnlineAudienceExpectations: number | null,
    projectOffilneAudienceExpectations: number | null,
    projectMediaCoverageExpectations: number | null,
    calendarPlanText: string | null,
    projectRelevance: string,
    projectPrStrategy: string,
    projectExpectations: string,
    projectBudgetSources: string,
    grantType: GrantType | null,
    grantAmount: number | null,
    leader: FestExpertEvaluationLeaderModel,
    photoSite: string,
    budgetPlanJson: BudgetRowModel[],
    presentation: FestExpertEvaluationFileModel | null
  ) {
    this.id = id
    this.formId = formId
    this.name = name
    this.description = description
    this.country = country
    this.city = city
    this.genre = genre
    this.instagramUrl = instagramUrl
    this.youtubeUrl = youtubeUrl
    this.vkontakteUrl = vkontakteUrl
    this.tiktokUrl = tiktokUrl
    this.telegramUrl = telegramUrl
    this.rutubeUrl = rutubeUrl
    this.maxUrl = maxUrl
    this.musicLinks = musicLinks
    this.projectName = projectName
    this.projectDescription = projectDescription
    this.projectStart = projectStart
    this.projectEnd = projectEnd
    this.projectPoint = projectPoint
    this.projectTargetAudience = projectTargetAudience
    this.projectRelevance = projectRelevance
    this.projectPrStrategy = projectPrStrategy
    this.projectExpectations = projectExpectations
    this.projectBudgetSources = projectBudgetSources
    this.grantType = grantType
    this.grantAmount = grantAmount
    this.projectOnlineAudienceExpectations = projectOnlineAudienceExpectations
    this.projectOffilneAudienceExpectations =
      projectOffilneAudienceExpectations
    this.projectMediaCoverageExpectations = projectMediaCoverageExpectations
    this.calendarPlanText = calendarPlanText
    this.leader = leader
    this.photoSite = photoSite
    this.budgetPlanJson = budgetPlanJson
    this.presentation = presentation
  }
}

export class FestExpertArtistGetResponse {
  @autoserializeAs(FestExpertEvaluationArtistModel)
  artist: FestExpertEvaluationArtistModel;
  @autoserializeAs(EvaluationValuationModel)
  valuation: EvaluationValuationModel;
  @autoserializeAs(AvailableToEvaluateModel, "available_to_evaluate")
  availableToEvaluate: AvailableToEvaluateModel;

  constructor(
    artist: FestExpertEvaluationArtistModel,
    valuation: EvaluationValuationModel,
    availableToEvaluate: AvailableToEvaluateModel
  ) {
    this.artist = artist
    this.valuation = valuation
    this.availableToEvaluate = availableToEvaluate
  }
}
